import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { theme } from '../../../theme/theme'
import { Icon, IconChoices } from '../../common/Icon'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { societyQueries } from '../../../api/societies'
import { useAuthenticatedUserId } from '../../../hooks/useAuthenticatedUserId'

interface BlockedCalloutProps {
  selectedSocietyId?: string
  className?: string
}

export const BlockedCallout = ({
  selectedSocietyId,
  className,
}: BlockedCalloutProps): JSX.Element | null => {
  const { translate } = useAppTranslation()
  const authUserId = useAuthenticatedUserId() as string
  const { data: userIsBlockedSocietyIds } = useQuery(
    societyQueries.getUserBlockedSocietyIds()
  )
  const { data: societies } = useQuery(
    societyQueries.getUserSocieties(authUserId)
  )

  const blockedSocieties = societies?.filter((society) =>
    userIsBlockedSocietyIds?.includes(society._id)
  )

  if (!blockedSocieties || blockedSocieties.length === 0) {
    return null
  }

  const filteredBlockedSocieties = !selectedSocietyId
    ? blockedSocieties
    : blockedSocieties.filter((society) => society._id === selectedSocietyId)

  if (filteredBlockedSocieties.length === 0) {
    return null
  }

  const societyNames = filteredBlockedSocieties
    .map((society) => society.name)
    .join(', ')

  return (
    <div
      className={`flex items-center rounded bg-yellow p-4 ${className}`}
      role="alert"
    >
      <div>
        <Icon icon={IconChoices.INFORMATION} size={30} />
      </div>
      <p style={theme.textVariants.base} className="ml-3 text-black">
        {translate('blockedCallout.message', { societyNames })}
      </p>
    </div>
  )
}
